import * as ActionType from '../../constants/actionType';
import {RuntimeStateType} from '../../constants/actionType';
import {RuntimeMode, RuntimeType, TrayType} from '../../constants/dataEnum';

const initialState = {
  id: null,
  protocolName: '',
  status: RuntimeMode.IDLE,
  progress: 0,
  remainingTime: 0,
  pauseRemainingTime: false,
  csvRecordID: -1,
  dialog: {
    type: null,
    headerText: null,
    bodyText: null,
  },
  pausedOn: '',
  abortParam: true,
  onProgressRecordCSVIDs: [],
  doneRecordCSVIDs: [],
  reportVisible: false,
  readOnly: false,
  userExecutor: {},
  abortUserRequester: '',
  isTessaraProtocol: false,
  runtimeType: RuntimeType.NORMAL,
  trayType: TrayType.NORMAL_CADDY,
  executionCount: 0, // repeat execution n times after done
};

export default function runtimeStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_RUNTIME_PROTOCOL_ID:
      return {...state, id: action.id};
    case ActionType.SET_RUNTIME_PROTOCOL_NAME:
      return {...state, protocolName: action.protocolName};
    case ActionType.SET_RUNTIME_STATUS:
      return {...state, status: action.status};
    case ActionType.SET_RUNTIME_PROGRESS:
      return {...state, progress: action.progress};
    case ActionType.SET_RUNTIME_TRAY_TYPE:
      return {...state, trayType: action.data};
    case ActionType.SET_CSV_RECORD_ID:
      return {...state, csvRecordID: action.csvRecordID};
    case ActionType.SHOW_RUNTIME_DIALOG:
      return {...state, dialog: action.dialog};
    case ActionType.HIDE_RUNTIME_DIALOG:
      return {...state, dialog: {type: null, text: null, headerText: null}};

    case ActionType.SET_PAUSED_ON:
      return {...state, pausedOn: action.pausedOn};
    case ActionType.ADD_ON_PROGRESS_RECORD:
      return {
        ...state,
        onProgressRecordCSVIDs: [...state.onProgressRecordCSVIDs, action.onProgressRecordCSVIDs],
      };
    case ActionType.REMOVE_ON_PROGRESS_RECORD:
      return {
        ...state,
        onProgressRecordCSVIDs: [...state.onProgressRecordCSVIDs.filter((id) => id !== action.onProgressRecordCSVIDs)],
      };
    case ActionType.ADD_DONE_RECORD:
      return {
        ...state,
        doneRecordCSVIDs: [...state.doneRecordCSVIDs, action.newDoneRecordCSVIDs],
      };

    case ActionType.SET_ABORT_PARAM:
      return {...state, abortParam: action.abortParam};
    case ActionType.RESTORE_RUNTIMESTATE:
      return action.state;
    case ActionType.RESET_RUNTIMESTATE:
      return initialState;
    case ActionType.SET_RUNTIME_REPORT_VISIBLE:
      return {...state, reportVisible: action.data};
    case ActionType.SET_RUNTIME_PAUSE_REMAINING_TIME:
      return {...state, pauseRemainingTime: action.pause};
    case ActionType.SET_RUNTIME_REMAINING_TIME:
      return {...state, remainingTime: action.remainingTime};
    case ActionType.SET_READ_ONLY:
      return {...state, readOnly: action.readOnly};
    case ActionType.SET_RUNTIME_USER:
      return {...state, userExecutor: action.userExecutor};
    case ActionType.SET_RUNTIME_ABORT_USER_REQUESTER:
      return {...state, abortUserRequester: action.userRequester};
    case ActionType.SET_RUNTIME_TESSARA_PROTOCOL:
      return {...state, isTessaraProtocol: action.isTessaraProtocol};
    case ActionType.SET_RUNTIME_TYPE:
      return {...state, runtimeType: action.runtimeType};
    case RuntimeStateType.SET_EXECUTION_COUNT:
      return {...state, executionCount: action.count};
    default:
      return state;
  }
}
